import { render, staticRenderFns } from "./RichTextPreview.vue?vue&type=template&id=ceb5d338&scoped=true&"
import script from "./RichTextPreview.vue?vue&type=script&lang=js&"
export * from "./RichTextPreview.vue?vue&type=script&lang=js&"
import style0 from "./RichTextPreview.vue?vue&type=style&index=0&id=ceb5d338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb5d338",
  null
  
)

export default component.exports